import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'login';

const ELEMENTS = define({
  TITLE_TEXT: ['title', 'text'],
  EMAIL_INPUT: ['email', 'input'],
  PASSWORD_INPUT: ['password', 'input'],
  LOGIN_BUTTON: ['login', 'button'],
});

export const LOGIN_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
